// Product Variant Image Switcher
document.addEventListener('DOMContentLoaded', function() {
  console.log('Variant switcher loaded');
  
  const thumbnails = document.querySelectorAll('.product-single__thumbnail, .product__media-item, .product-single__thumbnails img');
  const mainImage = document.querySelector('.product__main-image img, .product-featured-img, .product-single__photo img');
  
  if (!thumbnails.length || !mainImage) {
    console.log('Elements not found');
    return;
  }
  
  console.log('Found ' + thumbnails.length + ' thumbnails');
  
  thumbnails.forEach(function(thumb) {
    thumb.style.cursor = 'pointer';
    
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Clicked');
      
      const img = this.querySelector('img') || this;
      let newSrc = img.src || img.getAttribute('data-src');
      
      if (newSrc) {
        newSrc = newSrc.replace(/_small|_compact|_medium|_thumb/g, '_large');
        mainImage.src = newSrc;
        console.log('Changed to:', newSrc);
      }
      
      thumbnails.forEach(t => t.style.opacity = '0.6');
      this.style.opacity = '1';
    });
  });
});